<template >
  <div>
    <div>
      <MenuAemps></MenuAemps>
    </div>
    <div class="buscador">
      <label for="search">Buscar</label>
      <input type="text" v-model="searchTerm" @input="buscarCartas" id="search" />
    </div>
    <div >
  <table id="tabla-edicion">
    <tr>
      <th>
      Principio Activo
      </th>
      <th>
      Nombre Comercial
      </th>
      <th>
      Asunto
      </th>
      <th>
      Fecha Simplificada
      </th>
      <th>
      Fecha de Publicación
      </th>
      <th>
      Editar
      </th>
      <th>
      Borrar
      </th>
    </tr>
    <tr v-for="cartas in cartasMostradas" :key="cartas.id">
      <td v-if="cartas">
        {{ cartas.principioActivo }}
      </td>
      <td>
        {{ cartas.nombreComercial }}
      </td>
      <td>
        <a :href="'/PDF/' + cartas.rutaPDF" target="_blank">{{ cartas.asunto }}</a>
      </td>
      <td>
        {{ cartas.fecha }}
      </td>
      <td>
      {{ cartas.fecha_publicacion_programada }}
      </td>
      <td>
        <router-link :to="{ name: 'editar', params:{id:cartas.id } }" class="editar-btn">Editar</router-link>
      </td>
      <td>
        <button name href="#" role="button" @click="confirmarBorrarCarta(cartas.id)" class="borrar-btn">Borrar</button>
      </td>
    </tr>
  
</table>
<div class="paginacion">
      <button @click="anteriorPagina" :disabled="paginaActual === 1" class="paginacion-btn">Anterior</button>
      <span class="paginacion-actual">Página {{ paginaActual }}</span>
      <button @click="siguientePagina" :disabled="paginaActual === totalPaginas" class="paginacion-btn">Siguiente</button>
    </div>
      </div>
    </div>

 

</template>

<script>
import MenuAemps from './MenuAemps.vue'


export default {
  components: {
    MenuAemps,
  },
  data() {
    return {
      cartas: [],
      cartasFiltradas: [],
      searchTerm: "",
      paginaActual: 1,
      cartasPorPagina: 10,
    };
  },

  created: function () {
    this.consultarCartas();

  },
  methods: {
    consultarCartas() {
  fetch("/php/lista.php")
    .then((respuesta) => {
      if (!respuesta.ok) {
        throw new Error(`Error en la solicitud: ${respuesta.status}`);
      }
      return respuesta.json();
    })
    .then((datosRespuesta) => {
     
      // Ahora datosRespuesta es un objeto JSON que puedes usar directamente
      if (Array.isArray(datosRespuesta)) {
        this.cartas = datosRespuesta;
        this.filtrarCartas(); // Aplicar filtros después de obtener los datos
      } else {
        console.error('La respuesta no es un array:');
      }
    })
    .catch((error) => {
      console.error('Error en la solicitud:', error);
    });
},


    buscarCartas() {
      this.paginaActual = 1;
      this.filtrarCartas();
    },
    filtrarCartas() {
      this.cartasFiltradas = this.cartas.filter((carta) => {
        const termino = this.searchTerm.toLowerCase();
        return (
          carta.principioActivo.toLowerCase().includes(termino) ||
          carta.nombreComercial.toLowerCase().includes(termino) ||
          carta.asunto.toLowerCase().includes(termino) ||
          carta.fecha.toLowerCase().includes(termino) ||
          carta.fecha_publicacion_programada.toLowerCase().includes(termino)
        );
      });
    },
    anteriorPagina() {
    if (this.paginaActual > 1) {
      this.paginaActual--;
    }
  },
  siguientePagina() {
    if (this.paginaActual < this.totalPaginas) {
      this.paginaActual++;
    }
  },
  confirmarBorrarCarta(id) {
      if (window.confirm('¿Estás seguro de que deseas borrar esta carta?')) {
        this.borrarCarta(id);
      }
    },
    borrarCarta(id) {
      try {
        fetch(`/php/lista.php?borrar=${id}`)
          .then((respuesta) => {
            if (!respuesta.ok) {
              throw new Error(`Error en la solicitud: ${respuesta.status}`);
            }
            return respuesta.json();
          })
          .then((datosRespuesta) => {
            if (datosRespuesta.success === 1) {
              // Actualiza la lista después de borrar
              this.consultarCartas();
            } else {
              console.error('Error al borrar:', datosRespuesta.message);
            }
          })
          .catch((error) => {
            console.error('Error en la solicitud:', error);
          });
      } catch (error) {
        console.error('Error:', error);
      }
    },
  },
  computed: {
    totalPaginas() {
      return Math.ceil(this.cartasFiltradas.length / this.cartasPorPagina);
    },
    cartasMostradas() {
      const cartasInvertidas = [...this.cartasFiltradas].reverse();
      const inicio = (this.paginaActual - 1) * this.cartasPorPagina;
      const fin = inicio + this.cartasPorPagina;

      return cartasInvertidas.slice(inicio, fin);
    },
  },
};
</script>
  